const MINIMUM_INFORMATION_LENGTH = 10;
const MAXIMUM_INFORMATION_LENGTH = 2000;

type AttachmentValidationItem = {
	error?: boolean;
};

type ValidateRequestDetailsParams = {
	attachments: AttachmentValidationItem[];
	information: string;
};

export function validateRequestDetails({attachments, information}: ValidateRequestDetailsParams) {
	const informationLength = information.trim().length;
	const hasAttachmentError =
		attachments.length === 0 || attachments.some(attachment => attachment.error);
	const hasInformationError =
		informationLength > 0 &&
		(informationLength < MINIMUM_INFORMATION_LENGTH ||
			informationLength > MAXIMUM_INFORMATION_LENGTH);

	return {
		hasAttachmentError,
		hasInformationError,
		shouldConfirmEmptyInformation:
			!hasAttachmentError && !hasInformationError && informationLength === 0,
	};
}

export {MAXIMUM_INFORMATION_LENGTH, MINIMUM_INFORMATION_LENGTH};
